/**
 * Enumeration of possible API request statuses for tracking request lifecycle.
 * @readonly
 * @enum {string}
 */
export const ApiRequestStatus = Object.freeze({
    /** Initial state when no request has been made */
    NotSent: "NotSent",
    /** Request is currently in progress */
    Pending: "Pending",
    /** Request completed successfully */
    Success: "Success",
    /** Request failed with an error */
    Error: "Error"
})